import { memo } from 'react';
import bones from '../../../assets/img/bones.png'
import bonesWebp from '../../../assets/img/bones.webp'
import ImgWithFallback from '../../ui/ImgWithFallback';

interface IEnemyDeadProps {
    maxEnemyHp: number
}

const EnemysDead = ({ maxEnemyHp }: IEnemyDeadProps) => {
    return (
        <>
            <ImgWithFallback
                src={bonesWebp}
                fallbackSrc={bones}
                classNames={'enemies__content-img enemies isDead'} />
            <div className="enemies__content-hp">
                <span style={{ width: `0%` }}></span>
                <p>0 / {maxEnemyHp}</p>
            </div>
        </>
    );
};

export default memo(EnemysDead);